import React, { useEffect } from 'react';

import { useTranslation } from "core/hooks/useTranslation";

import Modal from "core/ui-kit/modal";
import Form from 'core/ui-kit/form';
import { Col, Row } from 'core/ui-kit/layout';

import FormRulesBuilder from 'core/helpers/common/formRulesBuilder';

const Confirmation = ({
    isVisible,
    onCancel=Function.prototype,
    onOk=Function.prototype,
    message,
    title,
    cancelText,
    okText,
    hideCancel,
    noteConfigs: noteConfigsArg
}) => {
    const { t } = useTranslation();

    const [formInstance] = Form.useForm();

    const hasNote = Boolean(noteConfigsArg);

    const noteConfigs = hasNote ? {
        label: noteConfigsArg.label ?? t('backoffice.users.notes'),
        name: noteConfigsArg.name ?? "note",
        maxLength: noteConfigsArg.maxLength ?? 1000,
        className: noteConfigsArg.className ?? ""
    } : {}

    const noteInitialValues = {
        [noteConfigs.name]: ""
    }

    const handleOk = () => {
        if(hasNote){
            formInstance.submit()
        } else {
            onOk();
            onCancel();
        }
    }

    const onFormSubmit = data => {
        onOk(data[noteConfigs.name]);
        onCancel();
    }

    useEffect(() => {
        if(!isVisible){
            formInstance.resetFields();
        }
    }, [isVisible])

    return (
        <Modal
            open={isVisible}
            title={ title }
            cancelText={cancelText ?? t('backoffice.common.no')}
            okText={okText ?? t('backoffice.common.yes')}
            onOk={handleOk}
            onCancel={onCancel}
            className="rt--modal-confirmation"
            hideCancelButton={hideCancel}
        >
            <span className='rt--title rt--font-normal rt--font-regular rt--text-center'>{message}</span>
            {
                hasNote && (
                    <Form
                        form={formInstance}
                        initialValues={noteInitialValues}
                        onFinish={onFormSubmit}
                        className={noteConfigs.className}
                    >
                        <Row gutter={[16, 12]}>
                            <Col span={24} >
                                <Form.Textarea
                                    label={noteConfigs.label}
                                    name={noteConfigs.name}
                                    rules={
                                        new FormRulesBuilder(t).required().maxCharactersCount(noteConfigs.maxLength).minCharactersCount(6).build()
                                    }
                                    className="rt--form-item-without-margin"
                                    placeholder={`${t('backoffice.common.enter')} ${noteConfigs.label}`}
                                    maxLength={noteConfigs.maxLength}
                                    rows={6}
                                />
                            </Col>    
                        </Row>
                    </Form>
                )
            }
        </Modal>
    )
}

export default Confirmation;